import iOS from 'assets/svg/app-store-logo.svg';
import Android from 'assets/svg/google-play-logo-invert.svg';

import * as S from './styles';

export type StoresButtonTypes = {
  link: string;
  platform: 'ios' | 'android';
  soon?: boolean;
};

const StoresButton = ({ link, platform, soon = false }: StoresButtonTypes) => {
  const stores = {
    android: {
      alt: 'Get it on Google Play',
      ico: Android,
    },
    ios: {
      alt: 'Download on the App Store',
      ico: iOS,
    },
  };

  return (
    <S.Wrapper
      soon={soon}
      {...(!soon && { href: link })}
      target="_blank"
      rel="noopener noreferrer"
      platform={platform}
    >
      <img src={stores[platform].ico} alt={stores[platform].alt} />
    </S.Wrapper>
  );
};

export default StoresButton;
